export type PasswordRequirement = {
  id: string;
  label: string;
  valid: boolean;
};

const SPECIAL_CHARACTERS = /[@#$%&*+]/;

export const getPasswordRequirements = (
  password: string,
): PasswordRequirement[] => [
  {
    id: "length",
    label: "At least 8 characters long",
    valid: password.length >= 8,
  },
  {
    id: "lowercase",
    label: "One lowercase character",
    valid: /[a-z]/.test(password),
  },
  {
    id: "uppercase",
    label: "One uppercase character",
    valid: /[A-Z]/.test(password),
  },
  {
    id: "special",
    label: "One special character (@ # $ % & * +)",
    valid: SPECIAL_CHARACTERS.test(password),
  },
  {
    id: "number",
    label: "One number",
    valid: /\d/.test(password),
  },
];

export const passwordsMatch = (password: string, confirmPassword: string) =>
  password.length > 0 && password === confirmPassword;

export const isPasswordPolicyValid = (
  password: string,
  confirmPassword: string,
) =>
  getPasswordRequirements(password).every((requirement) => requirement.valid) &&
  passwordsMatch(password, confirmPassword);
